var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpAgile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.416 3.66663H4.58268C2.55764 3.66663 0.916016 5.30825 0.916016 7.33329V36.6666C0.916016 38.6917 2.55764 40.3333 4.58268 40.3333H39.416C41.4411 40.3333 43.0827 38.6917 43.0827 36.6666V7.33329C43.0827 5.30825 41.4411 3.66663 39.416 3.66663Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.916016 12.8334H43.0827",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 7.79163C7.42398 7.79163 7.5126 7.81851 7.58797 7.86887C7.66334 7.91923 7.72209 7.99081 7.75678 8.07456C7.79147 8.15831 7.80054 8.25047 7.78286 8.33938C7.76518 8.42828 7.72152 8.50995 7.65742 8.57405C7.59333 8.63815 7.51166 8.6818 7.42275 8.69949C7.33384 8.71717 7.24169 8.70809 7.15794 8.6734C7.07419 8.63871 7.00261 8.57997 6.95224 8.5046C6.90188 8.42922 6.875 8.34061 6.875 8.24996C6.875 8.1284 6.92329 8.01182 7.00924 7.92587C7.0952 7.83991 7.21178 7.79163 7.33333 7.79163Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 7.79163C12.924 7.79163 13.0126 7.81851 13.088 7.86887C13.1633 7.91923 13.2221 7.99081 13.2568 8.07456C13.2915 8.15831 13.3005 8.25047 13.2829 8.33938C13.2652 8.42828 13.2215 8.50995 13.1574 8.57405C13.0933 8.63815 13.0117 8.6818 12.9228 8.69949C12.8338 8.71717 12.7417 8.70809 12.6579 8.6734C12.5742 8.63871 12.5026 8.57997 12.4522 8.5046C12.4019 8.42922 12.375 8.34061 12.375 8.24996C12.375 8.1284 12.4233 8.01182 12.5092 7.92587C12.5952 7.83991 12.7118 7.79163 12.8333 7.79163Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 7.79163C18.424 7.79163 18.5126 7.81851 18.588 7.86887C18.6633 7.91923 18.7221 7.99081 18.7568 8.07456C18.7915 8.15831 18.8005 8.25047 18.7829 8.33938C18.7652 8.42828 18.7215 8.50995 18.6574 8.57405C18.5933 8.63815 18.5117 8.6818 18.4227 8.69949C18.3338 8.71717 18.2417 8.70809 18.1579 8.6734C18.0742 8.63871 18.0026 8.57997 17.9522 8.5046C17.9019 8.42922 17.875 8.34061 17.875 8.24996C17.875 8.1284 17.9233 8.01182 18.0092 7.92587C18.0952 7.83991 18.2118 7.79163 18.3333 7.79163Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 29.3334H9.16667C8.66041 29.3334 8.25 29.7438 8.25 30.25V33.9167C8.25 34.423 8.66041 34.8334 9.16667 34.8334H12.8333C13.3396 34.8334 13.75 34.423 13.75 33.9167V30.25C13.75 29.7438 13.3396 29.3334 12.8333 29.3334Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22 23.8334C23.5188 23.8334 24.75 22.6022 24.75 21.0834C24.75 19.5646 23.5188 18.3334 22 18.3334C20.4812 18.3334 19.25 19.5646 19.25 21.0834C19.25 22.6022 20.4812 23.8334 22 23.8334Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8333 29.3334H20.1667C19.6604 29.3334 19.25 29.7438 19.25 30.25V33.9167C19.25 34.423 19.6604 34.8334 20.1667 34.8334H23.8333C24.3396 34.8334 24.75 34.423 24.75 33.9167V30.25C24.75 29.7438 24.3396 29.3334 23.8333 29.3334Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8333 29.3334H31.1667C30.6604 29.3334 30.25 29.7438 30.25 30.25V33.9167C30.25 34.423 30.6604 34.8334 31.1667 34.8334H34.8333C35.3396 34.8334 35.75 34.423 35.75 33.9167V30.25C35.75 29.7438 35.3396 29.3334 34.8333 29.3334Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 22H30.25C30.7362 22 31.2025 22.1932 31.5464 22.537C31.8902 22.8808 32.0833 23.3471 32.0833 23.8333V29.3333",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2493 22H13.7493C13.2631 22 12.7968 22.1932 12.453 22.537C12.1092 22.8808 11.916 23.3471 11.916 23.8333V29.3333",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22 23.8334V29.3334",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpAgile);
export default __webpack_public_path__ + "static/media/exp_agile.bf6346aa019fafab5be9b0ceffaacb75.svg";
export { ForwardRef as ReactComponent };